import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Img from '../images/profi.jpg';
import './css/About.css';

class About extends Component {
  render() {
    return (
      <section id='about'>
        <div className='header'>ABOUT ME</div>
        <Container className='container'>
          <Row className='justify-content-between row-skills'>

            <div className='hex-wrap'>
              <div className="hex">
                <i className='icon fab fa-css3-alt fa-2x' />
              </div>
              <div className="text-center">CSS3</div>
            </div>

            <div className='hex-wrap'>
              <div className="hex">
                <i className='icon fas fa-database fa-2x' />
              </div>
              <div className="text-center">MongoDB</div>
            </div>

            <div className='hex-wrap'>
              <div className="hex-medium">
                <img alt='redux' className='redux-medium' src="data:image/png;base64,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" />
              </div>
              <div className="text-center">Redux</div>
            </div>


            <div className='hex-wrap'>
              <div className="hex-big">
                <i className='icon-big fab fa-react fa-2x' />
              </div>
              <div className="text-center">React</div>
            </div>

            <div className='hex-wrap'>
              <div className="hex-big">
                <i className='icon-big fab fa-node-js fa-2x' />
              </div>
              <div className="text-center">NodeJS</div>
            </div>

            <div className='hex-wrap'>
              <div className="hex-medium">
                <i className='icon-medium fab fa-js-square fa-2x' />
              </div>
              <div className="text-center">JavaScript</div>
            </div>

            <div className='hex-wrap'>
              <div className="hex">
                <i className='icon fab fa-github fa-2x' />
              </div>
              <div className="text-center">GitHub</div>
            </div>

            <div className='hex-wrap'>
              <div className="hex">
                <i className='icon fab fa-html5 fa-2x' />
              </div>
              <div className="text-center">HTML5</div>
            </div>


          </Row>

          <Row className='description'>
            <Col xl='5' lg='5' sm='12'>
              <div>
                <img src={Img} alt='Bogdan Matei' className='profile-image' />
              </div>
            </Col>
            <Col className='about-text' xl='7' lg='7' sm='12'>
              <div>
                <p>
                  I am results-oriented, organized and enthusiastic professional with experience in non-tech roles that have allowed me to develop exceptional soft skills and become a superb communicator.

                </p>
                <p>
                  Graduated from the Le Wagon full-stack development course and I am now looking for my first full-time development role with mentorship and room to grow.


                </p>
                <p>
                  I really love the creativity and visual aspects of Front End and would like the opportunity to learn more about UI/UX.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}

export default About;
